import React from "react";

import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Faq from "../Pages/Faq/Faq";
import Faqcenter from "../Pages/Faq/Faqcenter";
import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function Faqtheme() {
  return (
    <>
      <Header />
      <Faq />
      <Faqcenter />
      <Footer />
    </>
  );
}
